<template>
  <div class="projectPage">
    <Header
      :menuIndex="1"
      :banner="bannerImg"
      mainTitle="空管智慧运维解决方案"
      subTitle="助力空管高效运维"
    />
    <div class="navBar">
      <div class="container">
        <div
          class="item"
          v-for="(item, index) in navBarList"
          :key="index"
          :class="{ active: activeIndex == index }"
          @click="changeActiveIndex(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="container" ref="sectionA">
      <section class="sectionA">
        <div class="sec-title">{{ navBarList[0] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionAList" :key="index">
            <img :src="item.img" alt="" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="sectionB" ref="sectionB">
      <div class="container">
        <div class="sec-title">{{ navBarList[1] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionBList" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>
    <div class="container" ref="sectionC">
      <section class="sectionC">
        <div class="sec-title">{{ navBarList[2] }}</div>
        <div class="sec-sub-title">
          结合数字孪生技术，构建真实物理与仿真感知空间，通过可视化方式进行展示预测
        </div>
        <div class="content">
          <div class="tabs">
            <div
              class="item"
              :class="{ active: sectionCActiveIndex == index }"
              v-for="(item, index) in sectionCList"
              :key="index"
              @click="changeSectionC(index)"
            >
              <div class="tab" v-if="sectionCActiveIndex != index">
                {{ item.title }}
              </div>
              <div class="detail" v-if="sectionCActiveIndex == index">
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <span v-for="(item_s, indes_s) in item.desc" :key="indes_s">{{
                    item_s
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <img :src="sectionCList[sectionCActiveIndex].img" alt="" />
        </div>
      </section>
    </div>
    <div class="contactus">
      <div class="title">从这里开始，让数据用起来</div>
      <div class="btn"  @click="$router.push('/application')">联系我们</div>
    </div>
    <Foot />
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      bannerImg: require("@/assets/banner/5.jpg"),
      navBarList: ["产品优势", "核心功能", "产品展示"],
      activeIndex: 0,
      sectionAList: [
        {
          img: require('@/assets/chanpinyoushi/1.png'),
          title: "极简视觉风格",
          desc: "极简风格，自成一体，具有视觉识别度",
        },
        {
          img: require('@/assets/chanpinyoushi/2.png'),
          title: "深耕业务价值",
          desc: "深耕耦合业务，不仅是数据图形呈现",
        },
        {
          img: require('@/assets/chanpinyoushi/3.png'),
          title: "独有聚焦组件",
          desc: "自主研发高复杂度组件，突出视野焦点",
        },
        {
          img: require('@/assets/chanpinyoushi/4.png'),
          title: "好设计秒实现",
          desc: "所见即所得，快速获取高水准可视化效果",
        },
        {
          img: require('@/assets/chanpinyoushi/5.png'),
          title: "专业交付能力",
          desc: "支持高度定制，具有高质量售后服务能力",
        },
        {
          img: require('@/assets/chanpinyoushi/6.png'),
          title: "平台组合赋能",
          desc: "与数栖无缝对接，整合数据应用，更具竞争力",
        },
      ],
      sectionBList: [
        {
          img: require('@/assets/hexingongneng/1.png'),
          title: "工作空间",
          desc: "不同的工作空间的数据和成员是完全隔离的，多个公司/团队/组织可以实现独立管理，互不影响。",
        },
        {
          img: require('@/assets/hexingongneng/2.png'),
          title: "独特的视觉风格&多套视觉主题",
          desc: "内置多套极简风格的视觉主题，具有高度的可识别度，同时让观者的视线焦点聚焦在数据本事，突出数据价值。",
        },
        {
          img: require('@/assets/hexingongneng/3.png'),
          title: "待补充",
          desc: "待补充",
        },
        {
          img: require('@/assets/hexingongneng/4.png'),
          title: "实时数据渲染",
          desc: "支持轮询方式和持久连接（Websocket）方式实现数据的实时更新，并以动画方式展现实时数据的变化。",
        },
        {
          img: require('@/assets/hexingongneng/5.png'),
          title: "快照",
          desc: "生成快照，用于备份和回复完整的数据屏配置。支持危险操作之前的手动生成获配置快照任务根据指定时间自动生成。",
        },
        {
          img: require('@/assets/hexingongneng/6.png'),
          title: "GIS地图",
          desc: "海量数据的地理空间数据展示，支持散点气泡层、符号层、热力层、轨迹层、飞线层、多边形填充层及三维实景层等。",
        },
      ],
      sectionCList: [
        {
          title: "智能工厂智慧决策中心",
          desc: ["隐患及时预警", "可控自动化", "精细化管理"],
          img: "https://dtwave-img.oss-cn-shanghai.aliyuncs.com/public/dtwave-2021/video/web/waveview/zhgc.png",
        },
        {
          title: "深圳巴士驾驶舱",
          desc: ["动态渲染", "交互互动", "实现全态势感知"],
          img: "https://dtwave-img.oss-cn-shanghai.aliyuncs.com/public/dtwave-2021/video/web/waveview/szbs.png",
        },
        {
          title: "车辆系统健康监测",
          desc: ["3D车模建模", "层层拆解深入", "车辆实时监控"],
          img: "https://dtwave-img.oss-cn-shanghai.aliyuncs.com/public/dtwave-2021/video/web/waveview/bmw.jpg",
        },
        {
          title: "数栖大会场馆",
          desc: ["实时流动情况", "一体化管理", "人员动态展示"],
          img: "https://dtwave-img.oss-cn-shanghai.aliyuncs.com/public/dtwave-2021/video/web/waveview/sqdh.png",
        },
      ],
      sectionCActiveIndex: 0,
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 0;
        }
      });
    }, options);

    observer1.observe(this.$refs.sectionA);

    const observer2 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 1;
        }
      });
    }, options);

    observer2.observe(this.$refs.sectionB);

    const observer3 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 2;
        }
      });
    }, options);

    observer3.observe(this.$refs.sectionC);
  },
  methods: {
    changeActiveIndex(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.$refs.sectionA.scrollIntoView({ behavior: "smooth" });
          break;
        case 1:
          this.$refs.sectionB.scrollIntoView({ behavior: "smooth" });
          break;
        case 2:
          this.$refs.sectionC.scrollIntoView({ behavior: "smooth" });
          break;
      }
    },
    changeSectionC(index) {
      this.sectionCActiveIndex = index;
    },
  },
};
</script>
  
<style lang="scss" scoped>
.container {
  width: 1280px;
  margin: 0 auto;
}
.projectPage {
  .navBar {
    height: 55px;
    position: sticky;
    z-index: 100;
    top: 0;
    background-color: #fff;
    box-shadow: 0 1px 1px 0 #ebedf6;
    > .container {
      display: flex;
      align-items: center;
      .item {
        cursor: pointer;
        margin-right: 50px;
        font-size: 16px;
        line-height: 55px;
        color: #7a8ba6;
        position: relative;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-image: linear-gradient(90deg, #659eff 0, #2466ff 100%);
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 0;
          transition: all 0.3s;
        }
      }
      .item.active {
        &::after {
          opacity: 1;
        }
      }
    }
  }
  section {
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      width: 100%;
      padding-bottom: 72px;
      padding-top: 72px;
    }
  }
  .sectionA {
    padding-bottom: 72px;
    & > .content {
      display: grid;
      column-gap: 150px;
      row-gap: 70px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 132px 132px;
      .item {
        display: flex;
        img {
          width: 30px;
          height: 30px;
          margin-right: 15px;
        }
        .info {
          .title {
            color: #374567;
            font-size: 18px;
            font-weight: 600;
            line-height: 32px;
          }
          .desc {
            margin-top: 16px;
            color: #7a8ba6;
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            line-height: 24px;
            text-align: justify;
          }
        }
      }
    }
  }
  .sectionB {
    width: 100%;
    background-color: #f9faff;
    padding-bottom: 80px;
    .content {
      display: grid;
      column-gap: 25px;
      row-gap: 25px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 344px 344px;
      .item {
        position: relative;
        background-color: #fff;
        img {
          position: absolute;
          width: 148px;
          height: 148px;
          bottom: 5px;
          right: 14px;
        }
        .title {
          font-weight: 600;
          margin-left: 32px;
          margin-top: 32px;
          height: 32px;
          font-size: 18px;
          color: #374567;
          line-height: 32px;
          text-align: left;
        }
        .desc {
          margin-right: 32px;
          padding-top: 8px;
          margin-left: 32px;
          letter-spacing: 1.5px;
          font-size: 14px;
          text-align: justify;
          color: #7a8ba6;
          line-height: 24px;
        }
      }
    }
  }
  .sectionC {
    width: 100%;
    padding-bottom: 80px;
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      padding: 70px 0 0 0;
    }
    .sec-sub-title {
      font-size: 14px;
      color: #7a8ba6;
      line-height: 24px;
      max-width: 1280px;
      margin: 24px auto 72px auto;
      text-align: center;
    }
    .content {
      width: 100%;
      .tabs {
        width: 100%;
        display: flex;
        background-color: #f9faff;
        .item {
          flex: 1;
          height: 136px;
          cursor: pointer;
          .tab {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #374567;
            font-weight: 500;
            text-align: center;
          }
          .detail {
            .title {
              margin-top: 32px;
              margin-left: 24px;
              font-weight: 600;
              font-size: 18px;
              color: #374567;
              line-height: 24px;
              text-align: left;
              height: 24px;
              width: 352px;
            }
            .desc {
              margin-top: 10px;
              margin-left: 24px;
              font-size: 14px;
              color: #7a8ba6;
              line-height: 24px;
              span {
                margin-right: 12px;
              }
            }
          }
        }
        .item.active {
          width: 455px;
          height: 136px;
          border-top: 4px solid #2468ff;
          background-color: #fff;
        }
      }
      img {
        width: 100%;
        height: 720px;
      }
    }
  }
  .contactus {
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(
      90deg,
      rgb(251, 252, 255),
      rgb(228, 234, 252) 75%,
      rgb(202, 222, 255)
    );
    .title {
      font-size: 30px;
      line-height: 40px;
      letter-spacing: 1.88px;
      text-align: center;
      color: #181818;
      padding-top: 49px;
      font-weight: 500;
    }
    .btn {
      margin-top: 20px;
      width: 108px;
      height: 36px;
      border-radius: 18px;
      background-image: linear-gradient(
        90deg,
        rgb(124, 172, 255),
        rgb(98, 140, 255)
      );
      margin: 20px auto;
      font-size: 14px;
      color: #fff;
      line-height: 36px;
      cursor: pointer;
      text-align: center;
      &:hover {
        background-image: linear-gradient(
          90deg,
          rgb(113, 165, 255),
          rgb(78, 125, 252)
        );
      }
    }
  }
}
</style>